export default {
  group: [
    {
      name: 'personal_data',
      fields: [
        {
          name: 'full_name',
          type: 'text',
          column_type: 'full-row',
        },
        {
          name: 'identification_number',
          type: 'text',
          column_type: 'full-row',
        },
        {
          name: 'date_of_birth',
          type: 'date',
          column_type: 'one-third-row',
        },
        {
          name: 'term_of_office_start',
          type: 'date',
          column_type: 'one-third-row',
        },
        {
          name: 'term_of_office_end',
          type: 'date',
          column_type: 'one-third-row',
        },
        {
          name: 'work_place',
          type: 'text',
          column_type: 'full-row',
        },
        {
          name: 'department',
          type: 'text',
          column_type: 'full-row',
        },
        {
          name: 'position',
          type: 'text',
          column_type: 'full-row',
        },
      ],
    },
    {
      name: 'contact_data',
      fields: [
        {
          name: 'working_phone_number',
          type: 'text',
          column_type: 'one-third-row',
        },
        {
          name: 'working_email',
          type: 'text',
          column_type: 'one-third-row',
        },
      ],
    },
  ],
};
